// extracted by mini-css-extract-plugin
export var editButton = "detailsPage-module--edit-button--3a862";
export var pageAdditionalInfos = "detailsPage-module--page-additional-infos--faef4";
export var pageBody = "detailsPage-module--page-body--426a5";
export var pageFooter = "detailsPage-module--page-footer--6c397";
export var pageFooterBack = "detailsPage-module--page-footer-back--55968";
export var pageIntro = "detailsPage-module--page-intro--3ca31";
export var pageIntroContainer = "detailsPage-module--page-intro-container--08369";
export var pageIntroImg = "detailsPage-module--page-intro-img--8d6be";
export var pageIntroTitle = "detailsPage-module--page-intro-title--86aeb";
export var pageTags = "detailsPage-module--page-tags--38700";
export var pageTaxo = "detailsPage-module--page-taxo--404b7";